module.exports = __webpack_public_path__ + "static/media/screenshot-2.8d10c3e8.png";